import React, { useState } from 'react';
import blank from '@/assets/images/blank.png';
import { endpoints } from '@/constants/urls';

const PartnerLogo = ({ title }) => {
  const [image, setImage] = useState(`${endpoints.API_IMAGES}fair-partner-logo.svg`);

  return (
    <img
      src={image}
      className="aridhia-partner-logo ui image logo"
      alt={title}
      onError={() => setImage(blank)}
    />
  );
};

export default PartnerLogo;
